<app-page-header [title]="'Privacy'" [subtitle]="'Privacy information for SampleStudio websites'"></app-page-header>
<div class="mb-6">
    <p>t.b.d.</p>
</div>